import { IEscrowJournalEntryData } from '../../types/accounting/data/IEscrowJournalEntryData';
import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';

export const getJournalEntryByIdAsync = async (id: string): Promise<IEscrowJournalEntryData> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IEscrowJournalEntryData>(`/timber/api/internal/escrow/journal_entries/${id}`)
    .then((response) => response.data)
    .catch(axiosErrorHandler);
